// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDG9FZYtr2yS7JM5s2PcpE251ZSQNsFE5U",
    authDomain: "my-professional-accountants.firebaseapp.com",
    projectId: "my-professional-accountants",
    storageBucket: "my-professional-accountants.appspot.com",
    messagingSenderId: "328252084513",
    appId: "1:328252084513:web:766f143988aa9cd6d76e60",
    measurementId: "G-395P912H2X"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
